<template>
    <div>
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead class="sash-main sas-head">
            <template v-slot:title><span class="sas-title" v-html="$t('students')"/></template>
            <template v-slot:center>
                <div class="sas-head-center">
                    <v-text-field outlined dense v-model="search['query']" @keyup.enter="searchStudents"
                                  @input="search.query !== '' ? showIcon = true : showIcon = false"
                                  prepend-inner-icon="mdi-magnify" @click:append="clearSearch"
                                  :append-icon="!showIcon ? '' : 'mdi-close'"/>
                    <v-btn color="primary" class="text-no-wrap" @click="searchStudents" v-text="$t('search')"/>
                </div>
            </template>
            <template v-slot:right>
                <div class="export-custom" style="margin-right: 8px">
                    <ExcelJs ref="exportParent" :buttonTitle="`${$t('exportParents')}`"
                             :file-name="`${$t('parentsLogin')}`" :headers="exportParentHeaders"
                             :rows="exportParentRows"/>
                    <span class="export-custom-btn" @click="exportStudentParents"></span>
                </div>
                <div class="export-custom">
                    <ExcelJs ref="exportStudents" :file-name="exportName" :headers="exportHeaders"
                             :rows="exportRows"/>
                    <span class="export-custom-btn" @click="prepareExport"></span>
                </div>
            </template>
        </SuperAdminSchoolHead>
        <div class="scl-ad">
            <SmartTable :current-page="currentPage" :page-size="pageSize" :schools="students"
                        :total-elements="totalElements" :totalPages="totalPages"
                        @leftClick="onLeftClick" @rightClick="onRightClick">
                <template v-slot:firstItem>
                    <div class="filter-class">
                        <v-select :items="filterClasses" item-text="classTitle" item-value="id"
                                  v-model="selectedClassId" :label="$t('classFilter')" outlined dense
                                  :class="{'no-border': selectedFilterClass}" @change="filterByClass"/>
                    </div>
                </template>
                <template v-slot:head>
                    <th>№</th>
                    <th v-html="$t('full_name')"/>
                    <th v-html="$t('class')"/>
                    <th v-html="$t('gender')"/>
                    <th v-html="$t('birthDate')"/>
                    <th/>
                </template>
                <template v-slot:body="{item}">
                    <td v-html="item['index'] + 1"/>
                    <td v-html="item['surname'] + ' ' + item['name']"/>
                    <td v-html="item['classTitle']"/>
                    <td v-html="item['gender'] === 0 ? 'М' : 'Ж'"/>
                    <td v-html="formatDOB(item['dateOfBirth'])"/>
                    <td>
                        <v-btn icon color="primary" @click="showDetailInfo(item['id'])">
                            <v-icon color="primary">mdi-information-outline</v-icon>
                        </v-btn>
                    </td>
                </template>
            </SmartTable>
        </div>
        <v-dialog v-model="showDetailModal" width="546">
            <v-card>
                <v-card-title>
                    <div class="header-2" v-html="`Полная информация`"/>
                </v-card-title>
                <v-divider/>
                <div class="pad-20">
                    <v-text-field :value="`${studentDetail.surname} ${studentDetail.name} ${studentDetail.middleName || ''}`"
                                  :label="$t('full_name')" readonly outlined type="text" dense/>
                    <v-text-field :value="studentDetail.phone" label="Телефон" readonly outlined type="text" dense/>
                    <template v-if="studentDetail.parents.length">
                        <v-text-field v-for="(parent, i) in studentDetail.parents" :key="i" dense
                                      :value="parent['parentUsername'] + ' / ' + parent['parentTitle']"
                                      :label="parent['parentType'] ? 'Мать' : 'Отец'" readonly outlined type="text"/>
                    </template>
                    <div class="course-titles">
                        <div v-html="$t('courses')" style="padding-bottom: 8px"/>
                        <span v-for="(course, i) in studentDetail.courses" :key="i"
                              v-html="i < studentDetail.courses.length-1 ? course[langObj[currentLang]] + ', '
                                   : course[langObj[currentLang]]"/>
                    </div>
                    <div class="btn-actions">
                        <v-btn color="primary" @click="showDetailModal = false">Закрыть</v-btn>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { limitNumbers } from '@/utils/limit-numbers'
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import { StudentService } from '@/_services/student.service'
import moment from 'moment'
import { RoleService } from '@/_services/role.service'
import { StudentClassService } from '@/_services/student-class.service'
import { PersonService } from '@/_services/person.service'
import { StudentParentService } from '@/_services/student-parent.service'
import ExcelJs from '@/components/excel-export/ExcelJs'
import { FileImportService } from '@/_services/file-import.service'
import SchoolClassService from '@/_services/school-class.service'
import PreLoader from '@/components/preloader/PreLoader'
import StudentCourseService from '@/_services/student-course.service'
const studentService = new StudentService()
const roleService = new RoleService()
const studentClassService = new StudentClassService()
const personService = new PersonService()
const studentParentService = new StudentParentService()
const fileImportService = new FileImportService()

export default {
    components: {PreLoader, ExcelJs, SuperAdminSchoolHead, SmartTable},
    data () {
        return {
            langObj: {ru: 'courseTitle', kg: 'courseTitleKG', en: 'courseCode'},
            firstLastNameRule: [
                v => !!v || this.$t('required'),
                v => !/\d/.test(v) || 'Должно быть без цифр'
            ],
            isAddFile: false,
            isMassDeleting: false,
            isSelectAll: false,
            classId: 0,
            studentObj: {
                address: '',
                avatar: '',
                chronicleYearId: 1,
                classId: 0,
                comeBy: '',
                dateOfBirth: '',
                email: '',
                enabled: true,
                gender: '',
                languageId: '',
                leaveBy: '',
                middleName: '',
                name: '',
                nationality: '',
                password: '',
                phone: '',
                pin: '',
                schoolId: 0,
                surname: '',
                username: '',
                roles: [0]
            },
            studentClassObj: {
                active: true,
                chronicleId: 1,
                classId: 0,
                studentId: 0
            },
            parentPersonObj: {
                address: '',
                avatar: '',
                dob: '05.05.1980',
                email: '',
                enabled: true,
                gender: 'MALE',
                job: '',
                jobPlace: '',
                languageId: 0,
                middleName: '',
                name: '',
                password: '',
                phone: '',
                roles: [],
                schoolId: 0,
                surname: '',
                username: ''
            },
            students: [],
            allStudents: [],
            classes: [],
            required: [v => !!v || this.$t('required')],
            isAddStudentModal: false,
            isStudentEdit: false,
            roles: [],
            languages: [],
            menu2: false,
            exportHeaders: [],
            exportRows: [],
            exportParentHeaders: [],
            exportParentRows: [],
            exportName: '',
            currentPage: 1,
            totalElements: 0,
            pageSize: 0,
            isDeleting: false,
            showDetailModal: false,
            studentDetail: {
                courses: [],
                parents: []
            },
            instrCourseObj: {},
            studentCourseCreate: {
                chronicleId: 0,
                classId: 0,
                courseId: 0,
                instructorId: 0
            },
            isLoading: false,
            totalPages: 1,
            filterClasses: [],
            selectedFilterClass: false,
            selectedClassId: '',
            showIcon: false,
            search: {
                query: ''
            },
            refreshClass: {
                schoolId: 0,
                chronicleId: 0,
                classId: 0
            },
            studentIds: {
                longList: []
            },
            existGradeStudents: [],
            deleteMassiveGradeIds: [],
            deleteReasons: [
                { title: 'В другом городе', value: 'CITY' },
                { title: 'В деревне', value: 'VILLAGE' },
                { title: 'В области', value: 'REGION' },
                { title: 'За границей', value: 'ABROAD' },
                { title: 'В архиве', value: 'ARCHIVE' },
                { title: 'Работает', value: 'WORK' },
                { title: 'Другое', value: 'OTHER' }
            ],
            deleteStudentObj: {
                chronicleId: 0,
                comment: '',
                quarterId: 0,
                reason: ''
            }
        }
    },

    computed: {
        userProfile () {
            return this.$store.state.account.profile
        },
        school () {
            return this.userProfile.schools[0]
        },
        currentLang () {
            return this.$root.$i18n.locale
        }
    },

    created () {
        this.studentObj.languageId = this.school.languageId
        this.parentPersonObj.languageId = this.school.languageId
        this.parentPersonObj.schoolId = this.school.id
        this.studentObj.chronicleYearId = this.school.chronicleId
        this.studentClassObj.chronicleId = this.school.chronicleId
        this.refreshClass.schoolId = this.school.id
        this.refreshClass.chronicleId = this.school.chronicleId
        this.fetchAllClasses()
        this.fetchRoles()
        this.fetchStudents(0, true)
    },

    methods: {
        limitNumbers: limitNumbers,
        fetchStudents (page, refreshAll) {
            this.isLoading = true
            studentService.getAllBySchool(
                this.userProfile.schools[0].id,
                this.search.query,
                false,
                page,
                10,
                this.classId)
                .then((res) => {
                    if (refreshAll) this.allStudents = JSON.parse(JSON.stringify(res))
                    this.totalElements = res.totalElements
                    this.pageSize = res.pageSize
                    this.totalPages = res.totalPages
                    this.currentPage = res.number + 1
                    if (res.content) {
                        this.students = res.content.map((i, index) => {
                            i.index = index
                            return i
                        })
                    } else this.students = []
                    this.isLoading = false
                })
                .catch((err) => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
        },
        filterByClass (klassId) {
            this.classId = klassId
            this.search.query = ''
            this.selectedFilterClass = true
            this.fetchStudents(0, false)
            this.prepareExport()
        },
        clearSearch () {
            this.showIcon = false
            this.search.query = ''
            this.searchStudents()
        },
        searchStudents () {
            this.selectedClassId = ''
            this.fetchStudents(0, false)
        },
        prepareExport () {
            this.exportHeaders = [
                this.$t('full_name'),
                this.$t('class'),
                this.$t('gender'),
                this.$t('birthDate'),
                'Логин/Пароль'
            ]
            studentService.getAllBySchool(
                this.userProfile.schools[0].id,
                this.search.query,
                false,
                0,
                this.totalElements,
                this.classId
            )
                .then((res) => {
                    if (res.content) {
                        this.exportRows = res.content.map(i => {
                            return [`${i.surname} ${i.name}`, i.classTitle, i.gender ? 'Ж' : 'М', i.dateOfBirth, i.username]
                        })
                    } else this.exportRows = []
                    this.isLoading = false
                }).catch((err) => {
                    this.$toast.error(err)
                this.isLoading = false
                })
            this.exportName = 'Умная школа: Ученики'
        },
        exportStudentParents () {
            this.isLoading = true
            studentParentService.getStudentParentList(this.school.id, this.selectedClassId).then((res) => {
                this.exportParentHeaders = ['ФИО Родителя', 'Логин Родителя', 'Пароль Родителя', 'ФИО студента']
                this.exportParentRows = res.map((item) => {
                    return [`${item['parentTitle'] + ' ' + item['parentMiddleName']}`, item['parentUsername'], item['parentUsername'], item.studentTitle]
                })
                this.$refs.exportParent.isExport = true
                this.isLoading = false
            }).catch((err) => {
                this.$toast.error(err)
                this.isLoading = false
            })
        },
        formatDOB (date) {
            return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY')
        },
        // selectAll () {
        //     this.students = this.students.map(i => {
        //         i.checked = !this.isSelectAll
        //         return i
        //     })
        // },
        // onMassDelete () {
        //     this.isMassDeleting = true
        // },
        // massDelete () {
        //     this.isLoading = true
        //     this.existGradeStudents = []
        //     this.deleteMassiveGradeIds = []
        //     this.studentIds.longList = this.students.filter(i => i.checked).map(i => i.id)
        //     GradeService.checkStudentsGrade(this.studentIds).then((res) => {
        //         if (res.length) {
        //             this.deleteMassiveGradeIds = res.map((grade) => grade.id)
        //             res.filter((obj, index, selfArr) =>
        //                 index === selfArr.findIndex((el) =>
        //                     (el.studentId === obj.studentId)
        //                 )).forEach((gradeStudent) => {
        //                     this.students.forEach((student) => {
        //                         if (gradeStudent.studentId === student.id) this.existGradeStudents.push(student)
        //                     })
        //                 })
        //             this.$modal.show('grade-exist-modal')
        //             this.isLoading = false
        //             this.isMassDeleting = false
        //         } else {
        //             this.deleteMassiveStudents()
        //         }
        //     }).catch((err) => {
        //         this.$toast.error(err)
        //         this.isLoading = false
        //     })
        // },
        // deleteStudentGrades () {
        //     this.isLoading = true
        //     GradeService.deleteStudentGrades({ longList: this.deleteMassiveGradeIds })
        //         .then(() => this.deleteMassiveStudents())
        //         .catch((err) => {
        //             this.$toast.error(err)
        //             this.isLoading = false
        //         })
        // },
        // deleteMassiveStudents () {
        //     studentService.massDelete(this.studentIds.longList).then(() => {
        //         this.$toast.success(this.$t('successDeleted'))
        //         this.isSelectAll = false
        //         this.fetchStudents(0, true)
        //         this.isMassDeleting = false
        //         this.isLoading = false
        //         this.$modal.hide('grade-exist-modal')
        //     }).catch(err => {
        //         this.$toast.error(err)
        //         this.isLoading = false
        //     })
        // },
        showDetailInfo (studentId) {
            this.isLoading = true
            studentService.getDetails(studentId).then((res) => {
                this.studentDetail = res
                this.getStudentCourses(studentId)
                this.showDetailModal = true
            }).catch(err => {
                this.$toast.error(err)
                this.isLoading = false
            })
        },
        // generateStudentCode () {
        //     this.isLoading = true
        //     studentService.getGeneratedCode(this.studentDetail.id).then((res) => {
        //         this.studentDetail.genCode = res['studentCode']
        //         this.isLoading = false
        //     }).catch((err) => {
        //         this.$toast.error(err)
        //         this.isLoading = false
        //     })
        // },
        async getStudentCourses (studentId) {
            await StudentCourseService.getByStudentIdAndChronicle(studentId, this.school.chronicleId)
                .then((res) => {
                    this.studentDetail.courses = res
                    this.isLoading = false
                }).catch(err => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
        },
        // onSelectClass (classId) {
        //     this.isLoading = true
        //     const studentId = this.students.find((student) => student.classId === classId).id
        //     this.getStudentCourses(studentId)
        // },
        // openDeleteCourseModal () {
        //     this.instrCourseObj = {}
        //     this.studentDetail.courses = []
        //     this.studentCourseCreate.classId = ''
        //     this.$modal.show('course-modal')
        // },
        // deleteCourseFromClass (courseObj, index) {
        //     this.isLoading = true
        //     const removeClassCourse = {
        //         classId: courseObj['studentClassId'],
        //         instructorCourseDtos: [{
        //             archived: true,
        //             courseId: courseObj.courseId,
        //             personId: courseObj.personId,
        //             schoolId: this.userProfile.schools[0].id
        //         }],
        //         yearId: this.userProfile.schools[0].chronicleId
        //     }
        //     StudentCourseService.deleteWithArray(removeClassCourse).then(() => {
        //         this.studentDetail.courses.splice(index, 1)
        //         this.$toast.success('Удалено!')
        //         this.isLoading = false
        //     }).catch((err) => {
        //         this.$toast.error(err)
        //         this.isLoading = false
        //     })
        // },
        // openRefreshClassCourseModal () {
        //     this.refreshClass.classId = ''
        //     this.$modal.show('refresh-course-modal')
        // },
        // submitRefreshClassCourse () {
        //     if (this.$refs.form.validate()) {
        //         this.isLoading = true
        //         StudentCourseService.refreshScheduleCourses(this.refreshClass).then(() => {
        //             this.$toast.success('Успешно обновлено!')
        //             this.isLoading = false
        //             this.closeRefreshCourseModal()
        //         }).catch((err) => {
        //             this.$toast.error(err)
        //             this.isLoading = false
        //         })
        //     }
        // },
        // closeRefreshCourseModal () {
        //     this.$modal.hide('refresh-course-modal')
        // },
        // downloadTemplate () {
        //     const a = document.createElement('a')
        //     a.download = 'Шаблон импорта Учеников.xlsx'
        //     a.href = '/docs/Шаблон_Окуучу.xlsx'
        //     a.click()
        // },
        // onDeleteStudent (item) {
        //     this.studentObj = item
        //     this.isDeleting = true
        //     this.deleteStudentObj.chronicleId = this.userProfile.schools[0].chronicleId
        //     this.deleteStudentObj.quarterId = this.userProfile.schools[0].quarterId
        // },
        // deleteStudent () {
        //     if (!this.deleteStudentObj.reason) {
        //         this.$toast.info('Выберите причину!')
        //         return
        //     }
        //     studentService._delete(this.studentObj.id, this.deleteStudentObj).then(() => {
        //         this.isDeleting = false
        //         this.$toast.success(this.$t('success'))
        //         this.fetchStudents(0, true)
        //     }).catch(err => {
        //         this.$toast.error(err)
        //         this.isDeleting = false
        //     })
        // },
        // onAddStudent () {
        //     this.isAddStudentModal = true
        //     this.isStudentEdit = false
        //     this.studentObj = {}
        //     this.parentPersonObj.name = ''
        //     this.parentPersonObj.phone = ''
        // },
        // onEditStudent (item) {
        //     this.isLoading = true
        //     studentService.getDetails(item.id).then(res => {
        //         this.studentObj.id = item.id
        //         this.studentObj.classId = item.classId
        //         this.studentObj.name = item.name
        //         this.studentObj.surname = item.surname
        //         this.studentObj.middleName = res.middleName
        //         this.studentObj.dateOfBirth = res.dateOfBirth
        //         this.studentObj.gender = item.gender === 0 ? 'MALE' : 'FEMALE'
        //         this.studentObj.phone = res.phone ? res.phone.replace('+', '') : ''
        //         this.studentObj.pin = res.pin
        //         this.parentPersonObj.name = res.parents && res.parents.length ? res.parents[0].parentTitle : ''
        //         this.isAddStudentModal = true
        //         this.isStudentEdit = true
        //         this.isLoading = false
        //     }).catch(err => {
        //         this.isLoading = false
        //         this.$toast.error(err)
        //     })
        // },
        fetchRoles () {
            roleService.listPageable(0).then(res => this.roles = res).catch(err => console.log(err))
        },
        fetchAllClasses () {
            SchoolClassService.getAllBySchool(this.userProfile.schools[0].id).then((res) => {
                this.classes = res.map(i => {
                    i.classTitle = `${i.classLevel} ${i.classLabel} ${i['languageName']}`
                    return i
                })
                this.filterClasses = JSON.parse(JSON.stringify(this.classes))
                this.filterClasses.unshift({ id: 0, classTitle: 'Показать все' })
            })
        },
        // submitStudent () {
        //     if (!this.$refs.studentForm.validate()) return
        //     this.isLoading = true
        //     this.search.query = ''
        //     this.studentObj.schoolId = this.userProfile.schools[0].id
        //     this.studentObj.chronicleYearId = this.userProfile.schools[0].chronicleId
        //     this.studentObj.roles = this.roles.filter(i => i.code === 'ROLE_STUDENT').map(i => i.id)
        //     const d = {
        //         classId: this.studentObj.classId,
        //         dateOfBirth: this.studentObj.dateOfBirth,
        //         name: this.studentObj.name,
        //         surname: this.studentObj.surname,
        //         middleName: this.studentObj.middleName,
        //         gender: this.studentObj.gender,
        //         pin: this.studentObj.pin,
        //         id: this.studentObj.id
        //     }
        //     if (this.isStudentEdit) {
        //         studentService.edit(d).then(() => {
        //             this.isAddStudentModal = false
        //             this.fetchStudents(0, true)
        //             studentClassService.getByStudent(d.id).then(res => {
        //                 this.studentClassObj.classId = this.studentObj.classId
        //                 this.studentClassObj.studentId = this.studentObj.id
        //                 if (res.length) {
        //                     this.studentClassObj.id = res[0].id
        //                     return studentClassService.edit(this.studentClassObj)
        //                 } else return studentClassService.create(this.studentClassObj)
        //             }).then(() => {
        //                 this.parentPersonObj.roles = this.roles.filter(i => i.code === 'ROLE_PARENT').map(i => i.id)
        //                 return studentParentService.getByStudent(this.studentObj.id)
        //             }).then(res => {
        //                 if (res['_embedded']) {
        //                     this.parentPersonObj.id = res['_embedded']['studentParentResourceList'][0].parentId
        //                     return personService.edit(this.parentPersonObj)
        //                 } else {
        //                     return personService.create(this.parentPersonObj).then(res => {
        //                         const studentParent = {
        //                             personId: parseInt(res.message),
        //                             parentalType: 'FATHER',
        //                             studentId: this.studentClassObj.studentId
        //                         }
        //                         return studentParentService.create(studentParent)
        //                     }).catch(err => this.$toast.error(err))
        //                 }
        //             }).then(() => {
        //                 this.$toast.success(this.$t('success'))
        //                 this.isLoading = false
        //             }).catch(err => this.$toast.error(err))
        //         }).catch(err => this.$toast.error(err))
        //     } else {
        //         studentService.create(this.studentObj).then((res) => {
        //             const studentId = parseInt(res.message)
        //             this.studentClassObj.classId = this.studentObj.classId
        //             this.studentClassObj.studentId = studentId
        //             studentClassService.create(this.studentClassObj).then(() => {
        //                 this.fetchStudents(0, true)
        //                 this.isAddStudentModal = false
        //                 this.$toast.success(this.$t('success'))
        //                 this.isLoading = false
        //             }).catch(err => {
        //                 this.$toast.error(err)
        //                 this.isLoading = false
        //             })
        //             this.parentPersonObj.roles = this.roles.filter(i => i.code === 'ROLE_PARENT').map(i => i.id)
        //             personService.create(this.parentPersonObj).then((res) => {
        //                 const studentParent = {
        //                     personId: parseInt(res.message),
        //                     parentalType: 'FATHER',
        //                     studentId: this.studentClassObj.studentId
        //                 }
        //                 studentParentService.create(studentParent).then((res) => {
        //                     console.log(res.message)
        //                 }).catch(err => {
        //                     this.$toast.error(err)
        //                     this.isLoading = false
        //                 })
        //             }).catch(err => {
        //                 this.$toast.error(err)
        //                 this.isLoading = false
        //             })
        //         })
        //     }
        // },
        onLeftClick () {
            this.currentPage--
            this.fetchStudents(this.currentPage - 1)
        },
        onRightClick () {
            this.currentPage++
            this.fetchStudents(this.currentPage - 1)
        }
        // onSubmit (data) {
        //     if (this.$refs.importFile.$refs.importForm.validate()) {
        //         this.isLoading = true
        //         const d = {
        //             chronicleId: data.chronicleId,
        //             languageId: data.languageId,
        //             file: data.file,
        //             schoolId: this.userProfile.schools[0].id
        //         }
        //         if (data['isIsouMode']) {
        //             fileImportService.importIsouStudent(d).then(() => {
        //                 this.$toast.success(this.$t('success'))
        //                 this.isAddFile = false
        //                 this.fetchStudents(0, true)
        //                 this.isLoading = false
        //             }).catch(err => {
        //                 this.isLoading = false
        //                 this.$toast.error(err)
        //             })
        //         } else {
        //             fileImportService.importStudent(d).then(() => {
        //                 this.$toast.success(this.$t('success'))
        //                 this.isAddFile = false
        //                 this.fetchStudents(0, true)
        //                 this.isLoading = false
        //             }).catch(err => {
        //                 this.$toast.error(err)
        //                 this.isLoading = false
        //             })
        //         }
        //     }
        // }
    }
}
</script>

<style lang="scss">
.course-titles {
    .label {
        font-size: 13px;
        color: #838080;
    }
}

.head-title {
    margin-bottom: 20px;
}

.v-form {
    background: #FFFFFF;
    border-radius: 7px;
    padding: 20px 40px;

    > div.form-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .v-input--radio-group {
            margin-right: 20px;
        }

        .profile-edit {
            background: #FFFFFF;
            box-shadow: 0 4px 4px rgba(0, 0, 0, 0.08);
            width: 24px;
            height: 24px;
            border-radius: 50%;
            position: absolute;
            right: 0;
            bottom: 0;

            img {
                margin-top: 5px;
            }
        }

        &.spacer {
            .v-text-field:first-child {
                margin-right: 20px;
            }
        }
    }
    .generate-code {
        background: #1976d2;
        color: #fff;
        padding: 0 5px;
        border-radius: 5px;
        width: 100%;
        text-align: center;
    }
}

.top-th {
    width: 60px;
}

.grade-exist-modal {
    .modal-container {
        height: 100%;
        overflow-y: auto;
        .grade-students {
            text-align: center;
            b {
                display: block;
                font-size: 18px;
                padding: 3px 0;
            }
        }
        .btn-actions {
            margin: 20px 0;
        }
    }
}
</style>
